import { create } from 'zustand';
import saleStatus from '@/typings/sale-status';

type saleStatusStore = {
  sale: saleStatus | null;
  loadSale(newSale?: saleStatus): void;
  hideMenus: boolean;
  setHideMenus(newHideMenus: boolean): void;
};

export const useSaleStatusStore = create<saleStatusStore>((set) => ({
  sale: null,
  hideMenus: false,
  loadSale(newSale?: saleStatus) {
    set(() => ({ sale: newSale }));
  },
  setHideMenus(newHideMenus: boolean) {
    set(() => ({ hideMenus: newHideMenus }));
  },
}));
